import * as React from "react";
import styled from "styled-components";
import { MESSAGE_FIELD } from "views/Constants";
import DecoratedValue from "views/components/messagelist/decoration/DecoratedValue";
import CustomHighlighting from "views/components/highlighting/CustomHighlighting";
import TypeSpecificValue from "views/components/TypeSpecificValue";
export const MessageWrapper = styled.div`
  white-space: pre-line;
  max-height: 6em; /* show 4 lines: line-height * 4 */
  overflow: hidden;
`;
const MessageFieldRow = ({ message, messageFieldType }) => /* @__PURE__ */ React.createElement(MessageWrapper, null, /* @__PURE__ */ React.createElement(CustomHighlighting, { field: "message", value: message.fields[MESSAGE_FIELD] }, /* @__PURE__ */ React.createElement(
  TypeSpecificValue,
  {
    field: "message",
    value: message.fields[MESSAGE_FIELD],
    type: messageFieldType,
    render: DecoratedValue
  }
)));
export default MessageFieldRow;
